/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const powerElectricalSystemsEnumsFaultTypeOptionEnum = {
    Overload: 'Overload',
    ShortCircuit: 'ShortCircuit',
    BreakerTrip: 'BreakerTrip',
    Other: 'Other',
} as const;

export type PowerElectricalSystemsEnumsFaultTypeOptionEnumKey =
    (typeof powerElectricalSystemsEnumsFaultTypeOptionEnum)[keyof typeof powerElectricalSystemsEnumsFaultTypeOptionEnum];

export type PowerElectricalSystemsEnumsFaultTypeOption = PowerElectricalSystemsEnumsFaultTypeOptionEnumKey;
